// Single duplexer instance should be reused across app so there would be only one socket open,
import { blogAppDefId } from '../../constants/apps';

// so instance creation function is memoized
type DuplexerClient = InstanceType<typeof import('./duplexer').Duplexer>;

let memoizedDuplexerClient: DuplexerClient | undefined;

export async function createDuplexerClient({
  getInstance,
}: {
  getInstance: () => string | undefined;
}) {
  if (memoizedDuplexerClient) {
    return memoizedDuplexerClient;
  }
  const { Duplexer } = await import(/* webpackChunkName: "duplexer" */ './duplexer');

  memoizedDuplexerClient = new Duplexer(`duplexer.wix.com`, {
    instanceUpdater: {
      // The SDK's type requires a string, but getInstance legitimately returns
      // undefined until the instance is available.
      getInstance: getInstance as () => string,
    },
  });
  return memoizedDuplexerClient;
}

export async function createDuplexerConnection({
  getInstance,
}: {
  getInstance: () => string | undefined;
}) {
  const client = await createDuplexerClient({ getInstance });
  return client.connect({ appDefId: blogAppDefId });
}
